import React, { useState } from 'react';
import { profileApi } from '../../../services/api';
import AddEditModal from '../shared/AddEditModal';
import ItemCard from '../shared/ItemCard';

const experienceFields = [
    { name: 'job_title', label: 'المسمى الوظيفي', type: 'text', required: true, placeholder: 'مهندس برمجيات أول' },
    { name: 'company', label: 'الشركة', type: 'text', required: true, placeholder: 'شركة التقنية' },
    { name: 'industry', label: 'القطاع', type: 'text', placeholder: 'التقنية' },
    { name: 'location', label: 'الموقع', type: 'text', placeholder: 'الرياض، السعودية' },
    { name: 'employment_type', label: 'نوع العمل', type: 'select', options: [
        { value: 'full-time', label: 'دوام كامل' },
        { value: 'part-time', label: 'دوام جزئي' },
        { value: 'contract', label: 'عقد' },
        { value: 'freelance', label: 'عمل حر' },
        { value: 'internship', label: 'تدريب' }
    ]},
    { name: 'start_date', label: 'تاريخ البداية', type: 'month', placeholder: '2020-01' },
    { name: 'end_date', label: 'تاريخ النهاية', type: 'month', placeholder: '2023-12' },
    { name: 'is_current', label: 'أعمل هنا حالياً', type: 'checkbox' },
    { name: 'description', label: 'الوصف', type: 'textarea', placeholder: 'وصف موجز لدورك...' },
    { name: 'achievements', label: 'الإنجازات الرئيسية', type: 'list', placeholder: 'أضف إنجاز...' },
    { name: 'technologies', label: 'التقنيات المستخدمة', type: 'tags', placeholder: 'أضف تقنية...' },
    { name: 'skills_tags', label: 'المهارات', type: 'tags', placeholder: 'أضف مهارة...' },
    { name: 'importance', label: 'الأهمية', type: 'importance' }
];

export default function Experience({ profile, onRefresh }) {
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const experiences = profile?.experience || [];

    const handleAdd = () => {
        setEditItem(null);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف هذه الخبرة؟')) return;
        setLoading(true);
        try {
            await profileApi.deleteExperience(id);
            onRefresh('experience');
        } catch (err) {
            alert('فشل في حذف الخبرة');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (editItem) {
                await profileApi.updateExperience(editItem.id, data);
            } else {
                await profileApi.addExperience(data);
            }
            setShowModal(false);
            onRefresh('experience');
        } catch (err) {
            alert('فشل في حفظ الخبرة');
        } finally {
            setLoading(false);
        }
    };

    const formatDateRange = (start, end, isCurrent) => {
        if (!start) return '';
        const startStr = start;
        const endStr = isCurrent ? 'حالياً' : (end || 'حالياً');
        return `${startStr} - ${endStr}`;
    };

    const renderCard = (exp) => (
        <ItemCard
            key={exp.id}
            title={exp.job_title}
            subtitle={`${exp.company}${exp.location ? ` • ${exp.location}` : ''}`}
            meta={[
                formatDateRange(exp.start_date, exp.end_date, exp.is_current),
                exp.employment_type
            ].filter(Boolean)}
            description={exp.description}
            tags={exp.skills_tags}
            importance={exp.importance}
            achievements={exp.achievements}
            onEdit={() => handleEdit(exp)}
            onDelete={() => handleDelete(exp.id)}
        />
    );

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">الخبرات العملية</h2>
                <button className="add-button" onClick={handleAdd}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    إضافة خبرة
                </button>
            </div>

            {experiences.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                        </svg>
                    </div>
                    <h3 className="empty-state-title">لا توجد خبرات بعد</h3>
                    <p className="empty-state-description">أضف تاريخك المهني لبناء سيرة ذاتية مقنعة</p>
                    <button className="add-button" onClick={handleAdd}>أضف خبرتك الأولى</button>
                </div>
            ) : (
                <div className="items-grid">
                    {experiences.map(renderCard)}
                </div>
            )}

            {showModal && (
                <AddEditModal
                    title={editItem ? 'تعديل الخبرة' : 'إضافة خبرة'}
                    fields={experienceFields}
                    initialData={editItem || { employment_type: 'full-time' }}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
